import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { validateEmail } from '../../../helpers';
import Context from '../../../utils/context';
import RequestButton from '../../ui_kit/utilities/request_button';

import styles from './index.module.css';

const MailIcon = () => (
  <svg width='32' height='32' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default function UsersPasswordRecover({ defaultEmail }) {
  const [email, setEmail] = useState(defaultEmail || '');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const context = useContext(Context);

  const checkedEmail = validateEmail(email);

  const validate = (event) => {
    event.preventDefault();
    if (checkedEmail === false && email !== '') {
      setError('Please enter a valid email');
    } else {
      setError('');
    }
  };

  const onSubmit = (afterAction) => {
    if (!checkedEmail) {
      setError('Please enter a valid email');
      afterAction();
      return;
    }

    setError('');
    context.auth.userRecoverPassword(
      email,
      () => {
        setSubmitted(true);
        afterAction();
      },
      () => {
        setSubmitted(true);
        afterAction();
      }
    );
  };

  if (submitted) {
    return (
      <div className={styles.auth_page}>
        <div className={styles.auth_page_content}>
          <div className={styles.auth_card}>
            <div className={styles.check_email_header}>
              <div className={styles.check_email_icon_bg}>
                <MailIcon />
              </div>
              <div>
                <h1 className={styles.auth_heading}>Check your email</h1>
                <p className={styles.auth_subtitle}>
                  If an account with that email exists, we've sent instructions for resetting your password to
                </p>
                {email && <p className={styles.check_email_address}>{email}</p>}
              </div>
            </div>

            <Link to='/member/login' className={`${styles.auth_link} ${styles.auth_link_center}`}>
              Back to login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.auth_page}>
      <div className={styles.auth_page_content}>
        <div className={styles.auth_card}>
          <div className={styles.auth_card_header}>
            <h1 className={styles.auth_heading}>Forgot your password?</h1>
            <p className={styles.auth_subtitle}>No problem! We'll email you a link to create a new password.</p>
          </div>

          {error && <p className={styles.auth_error}>{error}</p>}

          <div className={styles.auth_field}>
            <label className={styles.auth_field_label} htmlFor='recover-email'>
              Email
            </label>
            <div className={styles.auth_input_wrap}>
              <input
                id='recover-email'
                type='email'
                name='email'
                autoComplete='email'
                className={styles.auth_input}
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                onBlur={validate}
                placeholder='you@example.com'
                required
              />
            </div>
          </div>

          <RequestButton
            request={onSubmit}
            recaptcha={true}
            disabled={checkedEmail ? '' : 'disabled'}
            classnames={styles.auth_button}
            cta='Send password reset link'
          />

          <Link to='/member/login' className={`${styles.auth_link} ${styles.auth_link_center}`}>
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
